import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type { TableRequestBody, TableResponseBody } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { ApiTableMergedState } from 'components/ApiTable/model/ApiTableModel';
import { selectTableRequestPayloadBase } from 'components/ApiTable/model/selectors/selectTableRequestPayloadBase';
import type { TableRowIdValue } from 'components/Table/model/TableModel';
import { predicate, record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { ApiHook } from 'utils/request/useApi';

export const loadApiTableRowIdsForSelectAll = async (
  api: ApiHook,
  state: ApiTableMergedState,
): Promise<TableRowIdValue[]> => {
  if (state.rowIdField === undefined) {
    throw new IpfError(
      'INVALID_STATE',
      'Row id key not provided to load all row ids',
    );
  }

  const requestPayload: TableRequestBody<any> = pipe(
    selectTableRequestPayloadBase(state),
    (payload) => ({
      ...payload,
      filters: state.rowSelectionFilter?.selectAllFilter
        ? {
            and: [
              payload.filters,
              state.rowSelectionFilter.selectAllFilter,
            ].filter(predicate.not(record.isEmpty)),
          }
        : payload.filters,
      sort: undefined, // save some performance, not needed
      columns: [state.rowIdField!],
    }),
  );
  const response = await api.request<
    TableResponseBody<any>,
    TableRequestBody<any>
  >({
    url: state.endpoint.apiEndpoint,
    method: 'POST',
    data: requestPayload,
  });
  return response.data.map(prop(state.rowIdField));
};
